import { Icon } from "@circle-react-shared/Icon";
import { BLOCK_TYPE_ICON_MAP } from "../constants";

export interface LayersTreeIconProps {
  type: string;
}

export const LayersTreeIcon = ({ type }: LayersTreeIconProps) => {
  const iconType = BLOCK_TYPE_ICON_MAP[type] || "24-builder-element-section";

  return (
    <span className="flex">
      <Icon type={iconType} size={24} className="!size-4" />
    </span>
  );
};
